import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { ArrowRight } from 'venuescanner-js/react/components/Objects/Icons/FeatherIcons';
import {
  LinkButton,
  SkipButtonContainer,
  SubscriptionPromoContainer,
  Title,
} from './components';
import PropTypes from 'prop-types';

export const links = [
  {
    text: 'No commision on bookings',
    href: 'https://venuescanner.webflow.io/landing/case-study/commission-free',
    gaLabel: 'zero_commisions',
  },
  {
    text: 'More bookings',
    href: 'https://venuescanner.webflow.io/landing/case-study/more-bookings',
    gaLabel: 'more_bookings',
  },
  {
    text: 'Higher value events',
    href: 'https://venuescanner.webflow.io/landing/case-study/higher-value-events',
    gaLabel: 'higher_value',
  },
  {
    text: 'Higher conversion from enquiry to booking',
    href: 'https://venuescanner.webflow.io/landing/case-study/higher-conversion',
    gaLabel: 'higher_conversion',
  },
  {
    text: 'More corporate bookings',
    href: 'https://venuescanner.webflow.io/landing/case-study/more-corporate-bookings',
    gaLabel: 'corporate_bookings',
  },
];

export default function SubscriptionPromo({ onClick }) {
  const handleClick = gaLabel => () => {
    onClick();
  };

  return (
    <SubscriptionPromoContainer>
      <Typography variant='subtitle1' color='secondary'>
        Take venue hire to the next level
      </Typography>
      <Title variant='h5' component='h1'>
        What more would you like from venue hire?
      </Title>
      <Stack spacing={2}>
        {links.map(({ text, href, gaLabel }) => {
          return (
            <LinkButton
              size='medium'
              variant='contained'
              key={href}
              href={href}
              target='_blank'
              startIcon={<ArrowRight />}
              onClick={handleClick(gaLabel)}
              rel='noreferrer'>
              {text}
            </LinkButton>
          );
        })}
      </Stack>
      <SkipButtonContainer>
        <Button
          variant='outlined'
          color='white'
          size='large'
          onClick={handleClick('skip')}>
          Skip
        </Button>
      </SkipButtonContainer>
    </SubscriptionPromoContainer>
  );
}

SubscriptionPromo.propTypes = {
  onClick: PropTypes.func.isRequired,
};
